/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { Drawer } from '@mui/material';

import { useNavigationDrawerStyles } from './NavigationDrawer.styles';

export type NavigationDrawerProps = {
  drawerOpen: boolean;
  drawerWidth: number;
};

type NavigationDrawerInnerProps = NavigationDrawerProps & {
  children: React.ReactNode;
};

export function NavigationDrawer(props: NavigationDrawerInnerProps) {
  const { drawerOpen, drawerWidth, children } = props;
  const classes = useNavigationDrawerStyles({ drawerWidth });

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={drawerOpen}
      classes={{ paper: classes.drawerPaper }}
    >
      {children}
    </Drawer>
  );
}
